/*
VisualViewport isn't widely supported yet (https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API#browser_compatibility)
But it's supported enough where we don't need a polyfill for behind browsers
The polyfill we used to have was mostly for mobile safari
*/

export const visualViewportPolyfill = () => {
  if (window.visualViewport) {
    return window.visualViewport;
  }

  const { documentElement } = window.document;

  return {
    height: documentElement.offsetHeight,
    offsetLeft: 0,
    offsetTop: 0,
    onresize: null,
    onscroll: null,
    pageLeft: documentElement.scrollLeft,
    pageTop: documentElement.scrollTop,
    scale: 1,
    width: documentElement.offsetWidth,
    onresize: null,
    onscroll: null
  };
};
